import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
/* import NotFound from "pages/404"; */
import "./App.css";
import ScrollToTop from "./components/scroll-to-top";
import Home from "./pages/home";
import About from "./pages/about";
import Contact from "./pages/contact";
import BusinessIntegrity from "./pages/sustainability";
import Project from "./pages/project";
import Leadership from "./pages/leadership";
import LeadershipSingle from "./pages/leadership-single";
import News from "./pages/news";
import FeaturedIn from "./pages/featured-in";
import NewsSingle from "./pages/news-single";
import Newsletter from "./pages/newsletter";
import Careers from "./pages/careers";
import CareersJobDetails from "./pages/careers-job-details";
import Page from "./pages/page";
import { OpenCloseContactContext } from "./contexts/contact";
import { LoaderContext } from "./contexts/loader";
import { WEB_ROUTES } from "./routes/web-routes";

import Gallery from "./pages/Gallery";
import GallerySingle from "./pages/gallery-single";
import CookieConsent from "./components/CookieConsent";
import ReactGA from "react-ga4";

function App() {
  ReactGA.initialize("G-9NL84H7KHH");

  const [openCloseContact, setOpenCloseContact] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      <OpenCloseContactContext.Provider
        value={{ openCloseContact, setOpenCloseContact }}
      >
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* PUBLIC ROUTES */}
            <Route index exact path={WEB_ROUTES.HOME} element={<Home />} />
            <Route path={WEB_ROUTES.ABOUT} element={<About />} />
            <Route path={WEB_ROUTES.LEADERSHIP} element={<Leadership />} />
            <Route
              path={WEB_ROUTES.LEADERSHIP + `/:leader`}
              element={<LeadershipSingle />}
            />
            <Route path={WEB_ROUTES.PROJECT} element={<Project />} />
            <Route path={WEB_ROUTES.IMPACT} element={<BusinessIntegrity />} />
            <Route path={WEB_ROUTES.NEWS} element={<News />} />
            <Route path={WEB_ROUTES.NEWS + `/:news`} element={<NewsSingle />} />
            <Route path={WEB_ROUTES.FEATURED_IN} element={<FeaturedIn />} />
            <Route path={WEB_ROUTES.CONTACT} element={<Contact />} />
            <Route path={WEB_ROUTES.NEWSLETTER} element={<Newsletter />} />
            <Route path={WEB_ROUTES.CAREERS} element={<Careers />} />
            <Route
              path={WEB_ROUTES.CAREERS + `/:jobRef`}
              element={<CareersJobDetails />}
            />
            <Route path={WEB_ROUTES.GALLERY} element={<Gallery />} />
            <Route
              path={WEB_ROUTES.GALLERY + `/:gallerySlug`}
              element={<GallerySingle />}
            />
            {/* <Route exact path="/404" element={<NotFound />} /> */}
            <Route exact path="/:slug/*" element={<Page />} />
            <Route path="/*" element={<Home />} />
            {/* <Route path="*" element={<NotFound />} /> */}
          </Routes>
          <CookieConsent />
        </BrowserRouter>
      </OpenCloseContactContext.Provider>
    </LoaderContext.Provider>
  );
}

export default App;
